module.exports = __webpack_public_path__ + "img/cgal-03.6504d704.jpg";